import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
const useAppConfig = () => {
  const context = useContext(AuthenticationContext);
  return context.config;
};
export { useAppConfig as default, useAppConfig };